import { render } from "./SaveSingleParcel.vue?vue&type=template&id=e29b0f0a&ts=true"
import script from "./SaveSingleParcel.vue?vue&type=script&lang=ts"
export * from "./SaveSingleParcel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__